<template>
  <div>
    <NaturalEntityForm :services="services" :naturalEntityId="naturalEntityId" />
  </div>
</template>

<script>
import LegalEntityForm from './LegalEntityForm'

export default {
  components: {
    LegalEntityForm
  },
  props: {
    legalEntityId: {
      type: Number,
      default: null
    },
    services: {
      type: Object,
      default: null
    }
  },
  data: () => ({}),
  methods: {},
  created() {},
  mounted() {}
}
</script>